import RequestService from './request-service';
import { AxiosResponse } from 'axios';

export default class LogsService extends RequestService {
  public getLogs = (locationId: string, offset: number): Promise<AxiosResponse> =>
    this.instance.get('logs', { params: { offset, locationId } });
}
